import React from "react";
import styled from "styled-components";
import { Color, dominant, transparentize, useTheme } from "@glossy";
import Item from "@komon/navigation/navbar/item";
import { useCurrentUserLocale } from "@linkfluence/core/user/use-cases";
import Icon from "@ui-kit/icon";
import Portrait from "@radarly/components/portrait/project";
import { useCurrentWorkspace } from "@radarly/core/workspace/use-cases";
import { tr } from "@radarly/i18n";
import { Project } from "@radarly/models/project";
import { Workspace } from "@radarly/models/workspace";

const StyledProject = styled(Item)`
  color: ${Color.Black54};
  font-size: 12px;
  cursor: pointer;
`;

const Chevron = styled(Icon)`
  margin: 0 0 4px 8px;
  vertical-align: bottom;
`;

const IpIcon = styled.div`
  margin-right: 12px;
  display: inline-block;
  vertical-align: middle;
  background-color: ${(props) => transparentize(0.85, dominant(props))};
  width: 28px;
  height: 28px;
  border-radius: 4px;
  padding-top: 4px;
  text-align: center;
`;

const WorkspacePicture = styled(Portrait)`
  margin-right: 12px;
  display: inline-block;
  vertical-align: middle;
  width: 28px;
  height: 28px;
`;

const Caption = styled.div`
  vertical-align: middle;
  display: inline-block;
  text-align: left;

  div {
    line-height: 14px;
    max-width: 220px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
`;

interface IProps {
  project: Project;
  workspace: Workspace;
  onClick: () => void;
}

const NavigationNavbarScope = ({ project, onClick }: IProps) => {
  const theme = useTheme();
  const locale = useCurrentUserLocale();
  const workspace = useCurrentWorkspace();
  return (
    <StyledProject onClick={onClick}>
      {workspace ? (
        <WorkspacePicture picture={workspace.imageUrl || project.imageUrl} />
      ) : (
        <IpIcon>
          <Icon glyph="pages" size="s" color={theme.dominant} />
        </IpIcon>
      )}
      <Caption>
        <div>{project.label}</div>
        <div>
          {workspace
            ? workspace.label
            : tr(locale, "CUSTOM_PAGE::NAVBAR::TITLE")}
        </div>
      </Caption>
      <Chevron glyph="chevron-down" size="xs" />
    </StyledProject>
  );
};

export default NavigationNavbarScope;
